import { useBuilderArticles } from '@/hooks/useBuilderArticles';
import { ArticleCard } from '../ArticleCard/ArticleCard';
import { CarouselContainer } from '../Carousel/Carousel';
import { LinkButton } from '../LinkButton/LinkButton';
import { ARTICLE_SIDEBAR_DEFAULT_LIMIT, ArticleSidebarInput } from './ArticleSidebar.types';

export const ArticleSidebar: React.FC<ArticleSidebarInput> = (props) => {
  const {
    title,
    moreLink,
    moreLinkLabel,
    autoSelectLatest = true,
    limit = ARTICLE_SIDEBAR_DEFAULT_LIMIT,
    articles: articleInputs = [],
    builderState: { state },
    tagVariant = 'primary',
  } = props;

  const articles = useBuilderArticles({
    autoSelectLatest,
    limit,
    latestArticles: state.featuredArticles,
    articleInputs,
  });

  if (!articles.length) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <h2 className="mb-4 text-[34px]">{title}</h2>

      {/* Shows 1 article at a time on all screen sizes */}
      <div className="[&>div:last-child]:flex [&>div:last-child]:justify-center">
        <CarouselContainer
          useCarousel={articles.length >= 2}
          settings={{
            slidesToShow: 1,
            slidesToScroll: 1,
            showArrows: true,
            responsive: [],
          }}
        >
          {articles.map((article, index) => (
            <ArticleCard key={`sidebar-${index}`} article={article} tagVariant={tagVariant} />
          ))}
        </CarouselContainer>
      </div>

      <div className="mt-4">
        <LinkButton link={moreLink} label={moreLinkLabel} size="medium" variant="primary" centered />
      </div>
    </div>
  );
};
